module.exports = __webpack_public_path__ + "static/media/trakt.7ad46795.svg";